<script>
/**
 * Imports
 */
import SignupPackagesGroup from "./../packages/SignupPackagesGroup.vue";

/**
 * Component: Packages: Item
 *
 * @author PH
 */
export default {
  props: ["id", "title", "groups", "settings", "fields"],

  data: function() {
    return {
      open: false,
      focused: false,
      tier: null,
      chappell_pt: null
    };
  },

  created: function() {
    this.open = this.settings.open;

    if (this.settings.tier) {
      this.tier = this.settings.tier;
    }
    if (this.settings.chappell_pt) {
      this.chappell_pt = this.settings.chappell_pt;
    }
  },

  computed: {
    visible: function() {
      /**
       * If the item is set to be shown only for specific tier,
       * this funmction is used for managing visibility.
       */
      if (this.tier) {
        return (
          this.tier ===
          this.$store.getters.getSectionSettings("packages", "tiers").current
        );
      }
      if (this.chappell_pt) {
        return (
          this.chappell_pt ===
          this.$store.getters.getSectionSettings("packages", "chappell").current
        );
      }

      return true;
    },

    hasGroups() {
      return !! this.groups.reduce((acc, group) => {
        return acc + this.getOptions(group.id).filter(option => this.isVisibleOption(option)).length
      }, 0);
    }
  },

  methods: {
    getOptions(group) {
      return this.fields.filter(field => {
        return field.group === group;
      });
    },

    toggleSection() {
      this.open = !this.open;
    },

    focusElement(e) {
      if (9 === e.keyCode) {
        this.focused = true;
      }
    },

    unfocusElement(e) {
      this.focused = false;
    },

    isVisable() {
      const visiable = this.visible && this.hasGroups;

      this.$store.commit("updateSectionGroups", {
        section: "packages",
        group: this.id,
        values: {
          visible: visiable
        }
      });

      return visiable;
    },

    isVisibleOption(option) {
      if (! option.settings.conditional) {
        return true;
      }

      const data = {
        visible: this.$store.getters.getConditionalChecker( option.settings.conditional ),
      };

      if (data.visible === undefined) {
        return true;
      }

      if (data.visible === false) {
        data.value = false;
      }

      this.$store.commit("updateInput", {
        id: option.id,
        section: "packages",
        values: data
      });

      return data.visible;
    }
  },

  components: { SignupPackagesGroup }
};
</script>

<template>
  <div
    class="signup-packages-item"
    :class="['signup-packages-item--' + id, {open: open}]"
    v-if="isVisable()"
  >
    <div class="signup-packages-item__title">
      <button
        type="button"
        :class="{focused: focused}"
        v-on:click="toggleSection()"
        v-on:keyup="focusElement"
        v-on:blur="unfocusElement"
      >{{title}}</button>
    </div>

    <div class="signup-packages-item__groups">
      <signup-packages-group
        v-for="group in groups"
        v-bind:key="group.id"
        v-bind:id="group.id"
        v-bind:title="group.title"
        v-bind:fields="getOptions(group.id)"
      ></signup-packages-group>
    </div>
  </div>
</template>

